jQuery('.js-trigger').click(function () {
    jQuery(this).toggleClass('open')
  
    let aria_status = jQuery(this).attr("aria-expanded")
  
    if (aria_status == 'false') {
      aria_status = 'true'
    } else {
      aria_status = 'false'
    }
  
    jQuery(this).attr('aria-expanded', aria_status)
  })
  
  // jQuery('.has-megamenu').addEventListener('keypress', function () {
    
  
  
  // })
  
  const dropdowns = document.querySelectorAll('.has-megamenu')
    
  for (const dropdown of dropdowns) {
    dropdown.addEventListener("keydown", function (event) {
  
      if (document.activeElement.classList.contains('has-megamenu')) {
  
        if (event.keyCode == 40) {
          event.preventDefault();
          dropdown.classList.add('open')
    
          const as = dropdown.querySelectorAll('a')
          as[1].focus()
  
        } else {
  
          jQuery('.has-megamenu').removeClass('open')
  
        }
  
      }
  
  
      if (event.keyCode == 27) {
        event.preventDefault();
        jQuery('.has-megamenu').removeClass('open')
      }
  
      
  
      // jQuery('.has-megamenu').removeClass('open')
  
      // if (event.keyCode == 9) {      
      //   if (!dropdown.contains(document.activeElement)) {
      //     dropdown.classList.remove('open')
      //   }
      // }
  
    })
  }
  
  //   .addEventListener("keydown", function (event) {
  //   if ((document.activeElement.classList.contains('has-megamenu')) && (event.keyCode === 40)) {
  //     event.preventDefault()
  //     // fromBody = true;
  //     // defaultBtn.focus();
  //     console.log(document.activeElement)
  //   }
  // });